import React, { useState } from 'react'
import Hamburger from '../../assets/images/svgs/hamburger.svg'
import './FlipCardComponent.scss'
import LightTool from '../../assets/images/IntegrationMontioring/light_tool.svg'
import CommonButtonComp from './CommonButtonComp/CommonButtonComp'
import { CSidebar, CSidebarNav, CNavTitle } from '@coreui/react'
import Close from '../../assets/images/IntegrationMontioring/close-icon.png'

const HamburgerMenu = () => {
  const [openSidePanel, setOpenSidePanel] = useState(false)
  return (
    <>
      {!openSidePanel && (
        <span className="hamburger-icon  cursor-pointer">
          <img src={Hamburger} alt="menu" onClick={() => setOpenSidePanel(true)} />
        </span>
      )}
      {openSidePanel && (
        <div>
          <CSidebar
            position="fixed"
            className={'sdf-sidebar-cnt'}
            overlaid={openSidePanel}
            visible={openSidePanel}
            // onMouseLeave={() => setOpenSidePanel(false)}
          >
            <CSidebarNav className="sdf-side-bar">
              <CNavTitle className="hamburger-title">
                <span className="tools-more-text">
                  <img src={LightTool} alt="tool-Icon" />

                  <span className="tools-and-more-text"> Tools & More</span>
                </span>
                <span className="close-btn">
                  <img src={Close} onClick={() => setOpenSidePanel(false)} />
                </span>
              </CNavTitle>
              <div className={'tools-border-bottom-light'}></div>

              <CommonButtonComp
                ButtonText={'Integration Message Tracker'}
                showModal={false}
                isSidePanel={true}
              />

              <CommonButtonComp
                ButtonText={'Ongoing Incidents'}
                showModal={false}
                isSidePanel={true}
              />

              <CommonButtonComp
                ButtonText={'Report Incident'}
                showModal={true}
                isSidePanel={true}
              />
            </CSidebarNav>
          </CSidebar>
        </div>
      )}
    </>
  )
}

export default HamburgerMenu
